import {Emisor} from "./emisor";
import {TipoDocumento} from "./tipo-documento.enum";

export class BillingConfiguration {
    id: number = null;
    customer: Emisor;
    documentType: TipoDocumento;
    serialNumber: String = "";
    consecutive: Number = 0;


    constructor(id: number = null, customer: Emisor = new Emisor(), documentType: TipoDocumento = null, serialNumber: String = "", consecutive: Number = 0) {
        this.id = id;
        this.documentType = documentType;
        this.serialNumber = serialNumber;
        this.consecutive = consecutive;
        this.customer = customer;
    }
}


// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/recursos/modelo/emisor-configuration.ts